module.exports = __webpack_public_path__ + "static/media/logo-sm-red-black.c826f4d0.png";